import React from 'react';
import { ZapIcon } from 'lucide-react';
import { howSteps } from '../../data/samplePrompts';
export function PromptDemo() {
  return <div className="mx-auto mt-12 max-w-3xl" data-id="element-209" data-mp="31p59y3gqrvz7">
      <h3 className="font-display text-xl font-black text-plum sm:text-2xl" data-id="element-210" data-mp="3gmnx51dru14j">
        <ZapIcon className="mr-1.5 inline h-5 w-5 -translate-y-0.5 text-blush" aria-hidden="true" data-id="element-211" data-mp="3gkl92mw6ii2g" />
        Voyez comment cela fonctionne
      </h3>

      <div className="mt-4 overflow-hidden rounded-2xl border border-plum/15 bg-white" data-id="element-212" data-mp="2nzblvnd29fqj">
        <ol className="divide-y divide-plum/10" data-id="element-213" data-mp="2izyqufc1d2cv">
          {howSteps.map((s, i) => <li key={s.title} className="flex gap-4 p-4 sm:p-5" data-id="element-214" data-mp="2xolfx8rgt8ha" data-mpi={i}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-plum font-display text-sm font-black text-white" data-id="element-215" data-mp="2xpwix6d36c7c">
                {i + 1}
              </span>
              <div className="min-w-0" data-id="element-216" data-mp="255o7yemq02eq">
                <p className="text-sm font-bold text-plum sm:text-base" data-id="element-217" data-mp="2097m5r2zu04t">{s.title}</p>
                <p className="mt-0.5 text-sm text-plum/65" data-id="element-218" data-mp="1sc40b2yyo61u">{s.desc}</p>
                {s.chips.length > 0 && <div className="mt-2 flex flex-wrap gap-1.5" data-id="element-219" data-mp="1wcxm9qsufas3">
                    {s.chips.map(c => <span key={c} className={`rounded-md px-2 py-0.5 text-xs font-semibold ${c.startsWith('[') ? 'bg-blush-soft text-blush-deep' : 'bg-lilac-soft text-grape-deep'}`} data-id="element-220" data-mp="213w8f70ij339">
                        {c}
                      </span>)}
                  </div>}
              </div>
            </li>)}
        </ol>

        <div className="flex flex-col items-center justify-between gap-1 bg-plum px-5 py-3 text-center sm:flex-row sm:text-left" data-id="element-221" data-mp="1dgek5lggin51">
          <p className="text-sm font-semibold text-white/80" data-id="element-222" data-mp="1nd16yfscfo9p">Vous copiez, vous collez, vous vérifiez.</p>
          <p className="text-sm font-black text-grape-soft" data-id="element-223" data-mp="2ttmm5ey8g2yu">Résultat structuré</p>
        </div>
      </div>
    </div>;
}